import { ranking, teamOf } from "@/lib/selectors";
import { MONTH_KEY } from "@/data/mock";

export const MONTH_NAMES = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
export const CURRENT_YEAR = Number(MONTH_KEY.slice(0, 4));
export const CURRENT_MONTH = Number(MONTH_KEY.slice(5));
export const YEARS = [CURRENT_YEAR - 1, CURRENT_YEAR];

const seedNum = (id) => Number(String(id).replace(/\D/g, "")) || 0;
const mockScore = (id, year, m) => 58 + ((seedNum(id) * 17 + m * 11 + year * 7) % 41);

export const monthTop = (s, cid) => ranking(s, cid).slice(0, 3);

export const yearRanking = (s, cid, year) => {
  const live = Object.fromEntries(ranking(s, cid).map((r) => [r.id, r.score]));
  const lastMonth = year < CURRENT_YEAR ? 12 : CURRENT_MONTH;
  return teamOf(s, cid)
    .map((c) => {
      const seeded = /^c\d+$/.test(c.id);
      const months = Array.from({ length: lastMonth }, (_, i) => i + 1)
        .map((m) => (year === CURRENT_YEAR && m === CURRENT_MONTH ? live[c.id] : seeded ? mockScore(c.id, year, m) : null))
        .filter((v) => v != null);
      return { ...c, months: months.length, score: months.length ? Math.round(months.reduce((a, b) => a + b, 0) / months.length) : 0 };
    })
    .sort((a, b) => b.score - a.score)
    .map((r, i) => ({ ...r, position: i + 1 }));
};

export const yearClosed = (year) => year < CURRENT_YEAR;
